// src/components/MemberCard.js
// The physical Lover's Card shown on every subscriber's dashboard
import './MemberCard.css'

export default function MemberCard({ profile }) {
  const tier = profile?.tier || 'gold'
  const name = profile?.display_name || 'Member'
  const since = profile?.created_at
    ? new Date(profile.created_at).toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
    : 'March 2026'

  const initials = name.split(' ').map(w => w[0]).join('').slice(0, 2).toUpperCase()

  const tierLabels = { gold: 'Gold', premium: 'Premium', platinum: 'Platinum' }
  const tierNums = { gold: 'I', premium: 'II', platinum: 'III' }
  const tierSubs = { gold: 'The Admirer', premium: 'The Companion', platinum: 'The Intimate Circle' }

  return (
    <div className={`member-card member-card--${tier}`}>
      <div className="member-card__bg-lines" />
      <div className="member-card__inner">
        <div className="member-card__top">
          <div className="member-card__logo">SKY BRI · PRIVATE</div>
          <div className={`member-card__tier-label member-card__tier-label--${tier}`}>
            {tierLabels[tier]}
          </div>
        </div>

        <div className="member-card__avatar">{initials}</div>

        <div className="member-card__info">
          <div className="member-card__name">{name}</div>
          <div className="member-card__subtitle">{tierSubs[tier]}</div>
        </div>

        <div className="member-card__bottom">
          <div className="member-card__num">
            <span className="member-card__num-label">Tier</span>
            <span className="member-card__num-val">{tierNums[tier]}</span>
          </div>
          <div className="member-card__since">
            <span className="member-card__since-label">Member since</span>
            <span className="member-card__since-val">{since}</span>
          </div>
        </div>
      </div>
    </div>
  )
}
